import { Controller } from "@hotwired/stimulus"

// The intro film, played in a dialog over the page rather than in the hero
// itself. Nothing plays until someone asks for it, so there is no autoplay to
// mute and no motion to suppress.
//
// The file is 28 MB, so the source is only attached on the first open — a
// <video> with a src set would start fetching on page load even with
// preload="none" in some browsers, and most visitors never press play.
//
// showModal() brings the browser's focus trap and Escape handling, and returns
// focus to the play button on close. Closing stops the film rather than
// leaving it playing to itself behind the backdrop.
export default class extends Controller {
  static targets = ["dialog", "video"]

  open() {
    if (!this.videoTarget.src) this.videoTarget.src = this.videoTarget.dataset.src
    this.dialogTarget.showModal()
    // An explicit press is the gesture browsers want, so this plays with sound.
    this.videoTarget.play()
  }

  close() {
    this.dialogTarget.close()
  }

  // A click that lands on the dialog itself is a click on the backdrop:
  // everything visible sits in the wrapper inside it.
  clickOutside(event) {
    if (event.target === this.dialogTarget) this.close()
  }

  stop() {
    this.videoTarget.pause()
    this.videoTarget.currentTime = 0
  }
}
